export enum USER_PERMISSION {
  STATISTICS = 'statistics',
  DOWNLOAD = 'download',
}
